import { NavigationReports } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { BrandRevenue } from "@src/components/modules/reports/brand/revenue";
import type { NavigationReportsProps } from "@src/components/widgets/AppSubNav/NavigationReports/NavigationReports";
import { DemoModule, Modules } from "@src/components/widgets/DemoModule";
import { createFileRoute } from "@tanstack/react-router";

const report: NavigationReportsProps["currentReport"] = {
  href: "/reports/invoiced-by-brand",
  title: () => t`Brand Billings`,
  isBeta: true,
};

const Page = () => (
  <MainLayout
    title={report.title()}
    navigation={<NavigationReports currentReport={report} />}
  >
    <DemoModule module={Modules.Reports}>
      <BrandRevenue report={report} />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/reports/invoiced-by-brand")({
  component: Page,
});
